import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Utensils, Coffee, Box, GraduationCap, Sparkles, CheckCircle, ArrowRight } from 'lucide-react';
import styles from './ProductCategories.module.css';

const ProductCategories = () => {
  const [activeCat, setActiveCat] = useState(0);

  const categories = [
    {
      title: "Food Packaging",
      icon: <Utensils size={20} />,
      data: [
        { 
          name: "Food Wrap Paper", 
          img: "/images/products/food-wrap-papper (1).png", 
          desc: "Our food wrap paper is moisture-resistant and grease-proof, specifically engineered to maintain the freshness and aroma of cooked meals while ensuring complete hygiene.",
          link: "/products/food-wrap-paper"
        },
        { 
          name: "Paper Plates", 
          img: "/images/products/Paper-Plates1 (1).png", 
          desc: "Heavy-duty eco-friendly plates crafted from multiple layers of recycled fiber, providing a sturdy and compostable alternative to plastic dinnerware.",
          link: "/products/paper-plates"
        },
        { 
          name: "Sugar Sachets", 
          img: "/images/products/Sugar-Sachets1 (1).png", 
          desc: "Precision-cut sugar sachets designed for food service applications, providing convenient portion control with excellent barrier properties.",
          link: "/products/sugar-sachets"
        },
        { 
          name: "Pouches & Rolls", 
          img: "/images/products/Pouches-Rolls1 (1).png", 
          desc: "Versatile pouches and rolls for various packaging applications, offering flexibility in size and shape with reliable performance.",
          link: "/products/pouches-rolls"
        }
      ]
    },
    {
      title: "Cup & Beverage",
      icon: <Coffee size={20} />,
      data: [
        { 
          name: "Paper Cup Sleeves", 
          img: "/images/products/Paper-Cup-Sleeves.jpeg", 
          desc: "Ergonomically designed sleeves that provide superior heat insulation, allowing customers to hold hot beverages comfortably while adding a premium branding layer.",
          link: "/products/paper-cup-sleeves"
        },
        { 
          name: "Ripple Paper Cup Sleeves", 
          img: "/images/products/Ripple-sleeve1 (1).png", 
          desc: "Triple-layered ripple wall construction provides the highest heat barrier and a unique texture for a luxury grip on takeaway hot drinks.",
          link: "/products/ripple-paper-cup-sleeves"
        }
      ]
    },
    {
      title: "Industrial Rolls",
      icon: <Box size={20} />,
      data: [
        { 
          name: "PE Coated Rolls", 
          img: "/images/products/pe-rolls.png", 
          desc: "High-grade polyethylene coated paper rolls that provide a perfect barrier against liquids and gases, ideal for moisture-sensitive industrial packaging.",
          link: "/products/pe-coated-rolls"
        },
        { 
          name: "Notebook Cover Jumbo Rolls", 
          img: "/images/products/Notebook- Cover1 (1).png", 
          desc: "Large-format jumbo rolls specifically designed for notebook cover production. Features superior strength and smooth surface for high-quality printing.",
          link: "/products/notebook-cover-jumbo-rolls"
        },
        { 
          name: "PE Silver Coated Envelope Paper", 
          img: "/images/products/PE-Silver-Coated-Envelope-Paper1 (1).png", 
          desc: "Premium silver-coated paper rolls for envelope manufacturing, providing excellent barrier properties and premium metallic finish.",
          link: "/products/pe-silver-coated-envelope-paper"
        }
      ]
    },
    {
      title: "Educational",
      icon: <GraduationCap size={20} />,
      data: [
        { 
          name: "Kids School Copy Cover", 
          img: "/images/products/Notebook- Cover1 (2).png", 
          desc: "Durable and brightly colored paper covers designed for school notebooks, ensuring long-lasting protection with a smooth finish for labels.",
          link: "/products/notebook-cover-jumbo-rolls"
        }
      ]
    },
    {
      title: "Specialty Papers",
      icon: <Sparkles size={20} />,
      data: [
        { 
          name: "Soap Stiffener Paper", 
          img: "/images/products/Soap-Stiffener-Paper1 (1).png", 
          desc: "A specialized high-thickness paper used for soap inner packaging to maintain the shape of the bar and prevent moisture from damaging the outer wrap.",
          link: "/products/soap-stiffener-paper"
        }
      ]
    }
  ];

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <p className={styles.topLabel}>Greeneri Product Range</p>
          <h2 className={styles.mainTitle}>Industry <span className={styles.orange}>Categories</span></h2>
        </div>

        {/* Categories - Now in a single row */}
        <div className={styles.categoryNavigator}>
          {categories.map((cat, index) => (
            <button 
              key={index} 
              className={`${styles.navBtn} ${activeCat === index ? styles.activeBtn : ''}`}
              onClick={() => setActiveCat(index)}
            >
              <div className={styles.btnIcon}>{cat.icon}</div>
              <span>{cat.title}</span>
            </button>
          ))}
        </div>

        {/* Detailed Product List */}
        <div className={styles.detailsGrid}>
          {categories[activeCat].data.map((product, pIdx) => (
            <div key={pIdx} className={styles.productCard}>
              <div className={styles.imageBox}>
                <img src={product.img} alt={product.name} />
              </div>
              <div className={styles.infoBox}>
                <h3>{product.name}</h3>
                <p>{product.desc}</p>
                <div className={styles.footerRow}>
                    <div className={styles.badges}>
                        <span><CheckCircle size={14} /> 100% Eco</span>
                        <span><CheckCircle size={14} /> Premium</span>
                    </div>
                    <Link to={product.link} className={styles.detailsBtn}>
                      View Details <ArrowRight size={16} />
                    </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;